






import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {

  }
})
export default class Home extends Vue {
  private  str= '[微笑]你还好吗？';
  created() {
    // document.addEventListener("visibilitychange", function() {
    //   if (document.hidden) {
    //     alert("浏览器进入后台");
    //   } else {
    //     alert("浏览器回到前台");
    //   }
    // });
  }
}
